import { useRef } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import TopImage from '/assets/images/top.svg';
import TopHoverImage from '/assets/images/top_hover.svg';

import { Nav } from '@web/app/shared/components/Nav';

export const TermsOfServicePage = () => {
    const { t } = useTranslation();
    const sectionRefs = useRef<React.RefObject<HTMLDivElement>[]>([]);
    if (sectionRefs.current.length !== 17) {
        sectionRefs.current = Array(17)
            .fill(null)
            .map(() => React.createRef<HTMLDivElement>());
    }

    const handleScrollToSection = (index: number) => {
        const headerHeight = 80;
        const sectionTop = sectionRefs.current[index].current?.getBoundingClientRect().top || 0;
        const offsetPosition = window.pageYOffset + sectionTop - headerHeight;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    const sections = [
        {
            title: t('termsOfService.title1.title'),
            text: t('termsOfService.title1.desc'),
        },
        {
            title: t('termsOfService.title2.title'),
            text: t('termsOfService.title2.desc'),
        },
        {
            title: t('termsOfService.title3.title'),
            text: t('termsOfService.title3.desc'),
        },
        {
            title: t('termsOfService.title4.title'),
            text: t('termsOfService.title1.desc'),
        },
        {
            title: t('termsOfService.title4.title'),
            text: t('termsOfService.title1.desc'),
        },
        {
            title: t('termsOfService.title5.title'),
            text: t('termsOfService.title5.desc'),
        },
        {
            title: t('termsOfService.title6.title'),
            text: t('termsOfService.title6.desc'),
        },
        {
            title: t('termsOfService.title7.title'),
            text: t('termsOfService.title7.desc'),
        },
        {
            title: t('termsOfService.title8.title'),
            text: t('termsOfService.title8.desc'),
        },
        {
            title: t('termsOfService.title9.title'),
            text: t('termsOfService.title9.desc'),
        },
        {
            title: t('termsOfService.title10.title'),
            text: t('termsOfService.title10.desc'),
        },
        {
            title: t('termsOfService.title11.title'),
            text: t('termsOfService.title11.desc'),
        },
        {
            title: t('termsOfService.title12.title'),
            text: t('termsOfService.title12.desc'),
        },
        {
            title: t('termsOfService.title13.title'),
            text: t('termsOfService.title13.desc'),
        },
        {
            title: t('termsOfService.title14.title'),
            text: t('termsOfService.title14.desc'),
        },
        {
            title: t('termsOfService.title15.title'),
            text: t('termsOfService.title15.desc'),
        },
        {
            title: t('termsOfService.title16.title'),
            text: t('termsOfService.title16.desc'),
        },
    ];

    return (
        <>
            <Nav title={t('termsOfService.title')} />
            <div className="w-full bg-background max-md:pt-0">
                <div className="sticky top-0 bg-background py-[18px] mb-[14px] text-center max-xs:py-1">
                    <span className="text-[#3A3C40] dark:text-sub-title text-[36px] font-semibold max-xs:hidden">
                        {t('termsOfService.title')}
                    </span>
                </div>
                <main className="px-[18px] text-base text-sub-title">
                    <div className="text-[18px] font-medium mb-4">{t('termsOfService.listTitle')}</div>
                    <ul className="inline-flex flex-col space-y-1 mb-[42px]">
                        {sections.map((section, index) => (
                            <li
                                key={index}
                                onClick={() => handleScrollToSection(index)}
                                className="cursor-pointer underline hover:text-[#2c72fa]"
                            >
                                {section.title}
                            </li>
                        ))}
                    </ul>

                    {sections.map((section, index) => (
                        <div key={index} ref={sectionRefs.current[index]} className="mb-[42px]">
                            <div className="text-[28px] text-text mb-[11px] font-semibold max-md:text-[20px]">
                                {section.title}
                            </div>
                            <div className="whitespace-pre-wrap">{section.text}</div>
                        </div>
                    ))}
                </main>
                <button
                    className="button-image !fixed bottom-[52px] right-[52px] max-md:bottom-6 max-md:right-[18px] group"
                    onClick={() => goToTop()}
                >
                    <img className="max-md:scale-[0.8387] cursor-pointer group-hover:hidden" src={TopImage} alt="" />
                    <img
                        className="max-md:scale-[0.8387] cursor-pointer hidden group-hover:block"
                        src={TopHoverImage}
                        alt=""
                    />
                </button>
            </div>
        </>
    );
};
